// 试卷管理的辅助混合
export const PaperManagerHelper = {
    computed: {
        // 总分
        totalScore() {
            if (!this.typeList.length) return 0;
            return this.typeList.reduce((score, next) => {
                let subjectScore = this.subjectTotalScore(next)
                return score + subjectScore
            }, 0)
        },
        // 试题总量
        subjectNum() {
            if (!this.typeList.length) return 0;
            return this.typeList.reduce((score, next) => {
                let subjectScore = this.subjectQuesSum(next)
                return score + subjectScore
            }, 0)
        },
    },
    watch: {
        typeList: {
            handler: function (val) {
                val.forEach((element) => {
                    element.SubjectNum = this.subjectQuesSum(element)
                    element.TotalScore = this.subjectTotalScore(element)
                });
            },
            deep: true,
            immediate: true
        },
    },
    methods: {
        // 题型下试题数量总和
        subjectQuesSum(subjectType) {
            let num = subjectType.SubjectList.length
            if (subjectType.RandomSubjectList) {
                num = num + subjectType.RandomSubjectList.reduce((val, next) => {
                    return val + (next.RoleSubNum || 0)
                }, 0)
            }
            return num
        },
        // 题型下所有试题总分
        subjectTotalScore(subjectType) {
            let score = subjectType.SubjectList.reduce((pre, cur) => {
                return (cur.Score || 0) + pre
            }, 0)
            if (subjectType.RandomSubjectList) {
                score = score + subjectType.RandomSubjectList.reduce((val, next) => {
                    return val + (next.RoleSubNum || 0) * (next.SubScore || 0)
                }, 0)
            }
            return score
        }
    },
}
